/* Shared feed items context. Split from provider to satisfy ESLint react-refresh. */

import { createContext } from "react";
import type { Id } from "../../convex/_generated/dataModel";
import type { FeedItemData } from "@/components/feed/FeedItemRow";

export interface FeedItemsContextValue {
  items: FeedItemData[];
  totalCount: number | undefined;
  provocativeCount: number;
  isFirstLoading: boolean;
  hasMore: boolean;
  isLoadingMore: boolean;
  loadMore: (count: number) => void;
  removeItem: (id: Id<"feedItems">) => void;
  completeItem: (id: Id<"feedItems">) => void;
  queueItem: (id: Id<"feedItems">) => void;
  backlogItem: (id: Id<"feedItems">) => void;
  sortOrder: "asc" | "desc";
  setSortOrder: (order: "asc" | "desc") => void;
}

export const FeedItemsContext = createContext<FeedItemsContextValue | null>(null);
